import type { Store } from '../data/stores';
import type { GlobalFiltros } from './filtros';

/**
 * CATÁLOGO EFECTIVO de un periodo (SPEC 2026-10-13, punto b).
 *
 * El catálogo que sirve la API es el de las tiendas ACTIVAS hoy en el ERP, y
 * una tienda que cerró desaparecía también de los periodos en que operó: en
 * septiembre Global sumaba C 482.722 contra los 482.841 de los renglones de la
 * API, y la diferencia era exactamente MR CELAYA.
 *
 * Efectivo = activas ∪ cerradas cuya última actividad cae dentro o después del
 * inicio del periodo APLICADO. En vivo (hoy) no entra ninguna cerrada.
 */
export function catalogoEfectivo(
  activas: Store[],
  cerradas: Store[],
  desde: string,
): Store[] {
  const ids = new Set(activas.map((s) => s.id));
  const vigentes = cerradas.filter(
    (s) => s.cerrada && s.cerrada.ultimaActividad >= desde && !ids.has(s.id),
  );
  return vigentes.length ? [...activas, ...vigentes] : activas;
}

/** ¿La cascada está vacía («Todas»)? Entonces entran TODOS los renglones de la API. */
export function cascadaVacia(filtros: GlobalFiltros): boolean {
  return (
    filtros.regional.length === 0 &&
    filtros.supervisor.length === 0 &&
    filtros.cadena.length === 0 &&
    filtros.tienda.length === 0
  );
}
